import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { RecommendationType } from '../../typings/recommendations';

import './RecommendationItemsList.css';
import * as keyset from './RecommendationItemsList.i18n';

const i18n = i18nFactory(keyset);

export interface RecommendationItemsListProps {
    type: RecommendationType;
    items: string[];
    totalNumber: number;
    cls?: string;
}

export class RecommendationItemsList extends React.PureComponent<
    RecommendationItemsListProps
> {
    render() {
        const { items, totalNumber, cls } = this.props;
        const otherItemsNumber = totalNumber - items.length;

        return (
            <div className={classNames('recommendation-items-list', cls)}>
                <span className={Bem.cls('recommendation-items-list', 'title')}>
                    {this.getNameTitle()}:
                </span>{' '}
                <span className={Bem.cls('recommendation-items-list', 'items')}>
                    {items.join(', ')}
                </span>
                {otherItemsNumber > 0 ? (
                    <span
                        className={Bem.cls(
                            'recommendation-items-list',
                            'more-sign'
                        )}
                    >
                        {' '}
                        {i18n('other-sign', { number: otherItemsNumber })}
                    </span>
                ) : null}
            </div>
        );
    }

    private getNameTitle = (): string => {
        const { type } = this.props;

        const itemsNameDict = {
            [RecommendationType.removePagesFromBlackList]: i18n('page-name')
        };

        if (!itemsNameDict[type]) {
            throw Error(
                `Тип рекомендации ${type} не поддерживается для отображения списка сущностей`
            );
        }

        return itemsNameDict[type];
    };
}
